import { useFormContext } from "react-hook-form";
import type { PaymentFormValues } from "./payment-types";

export function PersonalInfoDisplay() {
  const { getValues } = useFormContext<PaymentFormValues>();
  const personalInfo = getValues("personalInfo");
  const address = getValues("address");

  return (
    <div className="border rounded-lg p-4 bg-muted/40 space-y-1 text-sm text-n-text">
      <div className="flex gap-2">
        <span className="font-medium min-w-[80px]">Nome:</span>
        <span>{personalInfo?.name || "—"}</span>
      </div>
      <div className="flex gap-2">
        <span className="font-medium min-w-[80px]">CPF/CNPJ:</span>
        <span>{personalInfo?.cpf || "—"}</span>
      </div>
      <div className="flex gap-2">
        <span className="font-medium min-w-[80px]">CEP:</span>
        <span>{address?.cep || "—"}</span>
      </div>
      <div className="flex gap-2">
        <span className="font-medium min-w-[80px]">Endereço:</span>
        <span>
          {address?.logradouro
            ? `${address.logradouro}, ${address.numero}${address.complemento ? ` - ${address.complemento}` : ""}`
            : "—"}
        </span>
      </div>
      {address?.bairro && (
        <div className="flex gap-2">
          <span className="font-medium min-w-[80px]">Bairro:</span>
          <span>{address.bairro}</span>
        </div>
      )}
      {address?.cidade && (
        <div className="flex gap-2">
          <span className="font-medium min-w-[80px]">Cidade:</span>
          <span>
            {address.cidade}
            {address.estado ? ` - ${address.estado}` : ""}
          </span>
        </div>
      )}
    </div>
  );
}
